import './App.css';
import { useState, useEffect } from 'react';

function PayWall() {

  return (
    <div className="App">
      <header className="bg-gradient-to-r from-purple-600 to-blue-600 min-h-screen flex flex-col items-center justify-center text-white p-8">
        <h1 className="text-5xl font-bold mb-6">EntryHaven</h1>
        <h2 className="text-2xl text-center mb-8 max-w-2xl">The World's Largest Database of Opportunities for Artists & Photographers</h2>
        
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 mb-12 max-w-xl">
          <ul className="space-y-4 text-lg mb-8">
            <li className="flex items-center">
              <svg className="w-6 h-6 mr-2 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg>
              Thousands of curated opportunities
            </li>
            <li className="flex items-center">
              <svg className="w-6 h-6 mr-2 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg>
              Updated daily with new listings
            </li>
            <li className="flex items-center">
              <svg className="w-6 h-6 mr-2 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg>
              Never miss an opportunity again
            </li>
          </ul>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-purple-600 font-bold py-3 px-8 rounded-full hover:bg-gray-100 transition">
              $40/Year
            </button>
            <button className="bg-gradient-to-r from-pink-500 to-purple-500 text-white font-bold py-3 px-8 rounded-full hover:opacity-90 transition">
              $100 Lifetime
            </button>
          </div>
        </div>

        <p className="text-sm opacity-75">Join thousands of successful artists who found their next opportunity through EntryHaven</p>
      </header>
    </div>
  );
}

export default PayWall;
